import * as React from 'react'

import { classList } from 'react-classlist-helper'

import { LayoutProps } from './types'

export const MobileResourceHeader: React.FC<LayoutProps> = ({
  children,
  className,
}) => (
  <div
    className={classList({
      'tw:flex tw:items-center tw:p-3': true,
      [className || '']: !!className,
    })}
  >
    {children}
  </div>
)
